import React, { Suspense, Component, ReactNode } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18next";
import { BrowserRouter as Router } from "react-router-dom";

// Suppress annoying ResizeObserver errors in Chrome/React
const resizeObserverErrMsg = "ResizeObserver loop completed with undelivered notifications.";
const resizeObserverErrMsg2 = "ResizeObserver loop limit exceeded";

const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    (args[0].includes(resizeObserverErrMsg) ||
      args[0].includes(resizeObserverErrMsg2))
  ) {
    return;
  }
  originalError(...args);
};

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading</div>}>
      <Router>
        <App />
      </Router>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
